import React, { memo, useEffect, useState } from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import RightSideBar from './RightSideBar';
import background from '../../images/lit.png';
import LitOnlearning from '../../images/lit.png';
import LogoPlanos from '../../images/sp_lit.png';
import history from '../../utils/history';

const LoginBox = styled.div`
  padding: 2em;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  @media(max-width: 768px) {
    padding: 2em 1.5em;
    height: auto;
    min-height: 100vh;
    justify-content: flex-start;
    padding-top: 2rem;
  }
`;

const MobileHeader = styled.nav`
  display: none;
  
  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;
    width: 100%;
    background: #27aae1; /* Cor padrão do LIT */
    
    .navbar-brand {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      
      img {
        max-width: 120px;
        height: auto;
        max-height: 50px;
        object-fit: contain;
      }
    }
  }
`;

const NavLit = styled.nav`
  width: 100%;
  background-image: transparent;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    background: none;
    /* padding: 0; */
    margin: 0;
    border: none;
    color: #fff;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    &:hover {
      text-decoration: underline;
    }
  }
`;

const LogoutButton = styled.button`
  display: none;
  
  @media (max-width: 768px) {
    display: block;
    width: 100%;
    padding: 1rem;
    margin-top: 2rem;
    background: transparent;
    border: 2px solid #27aae1;
    color: #27aae1;
    font-size: 16px;
    font-weight: bold;
    text-transform: uppercase;
    cursor: pointer;
    border-radius: 8px;
    transition: all 0.3s ease;
    
    &:hover {
      background: #27aae1;
      color: #fff;
    }
    
    &:active {
      opacity: 0.8;
    }
  }
`;

function ConfirmarEmail({ location }) {
  const [isMobile, setIsMobile] = useState(false);
  const [tenantSettings, setTenantSettings] = useState(null);

  const handleResize = () => {
    const isMobile = window.innerWidth <= 768;
    setIsMobile(isMobile);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize(); // Calcular o valor inicial de isMobile

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    // Buscar configurações do tenant
    const getTenantSettings = () => {
      // Primeiro tenta pegar do domainSettings (usado no cadastro)
      const domainSettings = localStorage.getItem('domainSettings');
      if (domainSettings) {
        try {
          const parsed = JSON.parse(domainSettings);
          setTenantSettings(parsed);
          return;
        } catch (e) {
          console.error('Error parsing domainSettings', e);
        }
      }
      
      // Se não encontrar, tenta pegar do settings (usado no NavBarSuperior)
      const settings = localStorage.getItem('settings');
      const tenant = localStorage.getItem('loginTenant') || localStorage.getItem('tenant');
      
      if (settings && tenant) {
        try {
          const parsed = JSON.parse(settings);
          const tenantConfig = parsed[tenant];
          if (tenantConfig) {
            setTenantSettings(tenantConfig);
            return;
          }
        } catch (e) {
          console.error('Error parsing settings', e);
        }
      }
      
      // Se não encontrar nada, deixa null para usar padrão
      setTenantSettings(null);
    };
    
    getTenantSettings();
  }, []);

  // Obter logo do tenant ou usar padrão (mesma logo da tela de planos)
  const getLogo = () => {
    if (tenantSettings && tenantSettings.logoUrl) {
      return tenantSettings.logoUrl;
    }
    return LogoPlanos;
  };

  // Obter cor de background do tenant ou usar padrão
  const getBackgroundColor = () => {
    if (tenantSettings) {
      return tenantSettings.headerBackgroundColor || 
             tenantSettings.primaryBackgroundColor || 
             '#27aae1';
    }
    return '#27aae1'; // Cor padrão do LIT
  };

  // Função logout (mesma da tela de planos)
  const logout = () => {
    const loginTenantRaw = localStorage.getItem('loginTenant');
    const originRaw = localStorage.getItem('urlOriginParam');

    const loginTenant =
      loginTenantRaw && loginTenantRaw !== 'undefined'
        ? loginTenantRaw.toLowerCase()
        : '';
    const origin =
      originRaw && originRaw !== 'undefined' ? originRaw : '';

    let redirectLoginPath = '/';

    if (loginTenant) {
      redirectLoginPath = `/${loginTenant}`;
    }

    if (origin) {
      const separator = redirectLoginPath.includes('?') ? '&' : '?';
      redirectLoginPath = `${redirectLoginPath}${separator}o=${encodeURIComponent(
        origin
      )}`;
    }

    history.push({
      pathname: '/logout',
      state: {
        redirectLoginPath
      }
    });
  };

  return (
    <div id="login" className="container-fluid px-0">
      {isMobile && (
        <MobileHeader 
          className="navbar navbar-lit navbar-expand-lg p-2"
          style={{ background: getBackgroundColor() }}
        >
          <a className="navbar-brand">
            <img src={getLogo()} alt="Logo" />
          </a>
        </MobileHeader>
      )}
      <div className="row" id="confirm-email-screen">
        {!isMobile && (
          <div className="col-md-7 hide-in-mobile d-none d-md-flex bg-loginLeft big ">
            <img src={background} className="logo" alt="LIT" />
          </div>
        )}
        <div
          className="col-md-5"
          style={{
            background: '#f3f2f1',
            minHeight: '100vh',
            ...(isMobile && {
              width: '100%',
              padding: 0
            })
          }}
        >
          <LoginBox>
            <RightSideBar />
            {isMobile && (
              <LogoutButton onClick={logout}>
                SAIR
              </LogoutButton>
            )}
          </LoginBox>
        </div>
      </div>
    </div>
  );
}

export default memo(ConfirmarEmail);
